import React from "react"

import { Color } from "../../../../constants/V2/color"
import IconItem from "../../../elements/V2/IconItem"

const StoryblokInfoItem = ({
  blok,
}: Storyblok.BlokProps<Storyblok.IconItem>) => {
  return (
    <IconItem
      iconUrl={blok.icon.filename}
      iconAlt={blok.icon.alt}
      titleText={blok.titleText}
      bodyText={blok.bodyText}
      size="small"
      textColor={Color.Charcoal}
    />
  )
}

export default StoryblokInfoItem
